















































































































































































































































































































































import { permiso } from "@/shared/dtos/permiso";
import { rol_permiso } from "@/shared/dtos/rol_permiso";
import { MessageService } from "@/shared/services/message-service";
import rolModule from "@/store/modules/rol-module";
import { Component, Vue } from "vue-property-decorator";

@Component({
  $_veeValidate: { validator: "new" },
})
export default class RolesFormulario extends Vue {
  public searchQuery: string = "";
  public filterType: string = "";
  public selectedPreset: string = "";
  public saving: boolean = false;

  public permissionTypes = [
    { text: "Todos", value: "" },
    { text: "Solo Menú", value: "menu" },
    { text: "Solo Lectura", value: "read" },
    { text: "Solo Escritura", value: "write" },
    { text: "Solo Actualización", value: "update" },
    { text: "Solo Eliminación", value: "delete" },
    { text: "Solo Global", value: "global" },
  ];

  public presets = [
    { text: "Administrador Total", value: "admin" },
    { text: "Solo Lectura", value: "readonly" },
    { text: "Editor", value: "editor" },
    { text: "Usuario Básico", value: "basic" },
    { text: "Limpiar Todo", value: "clear" },
  ];

  async created() {
    await rolModule.getrol_ficha(this.$route.params.id);
  }

  public get datasource() {
    return rolModule.ficha_rol;
  }

  public get headers() {
    return [
      { text: "Módulo/Pantalla", value: "nombre", width: "25%" },
      {
        text: "Menú",
        align: "center",
        value: "permiso_menu",
        sortable: false,
        width: "10%",
      },
      {
        text: "Lectura",
        align: "center",
        value: "permiso_read",
        sortable: false,
        width: "10%",
      },
      {
        text: "Escritura",
        align: "center",
        value: "permiso_write",
        sortable: false,
        width: "10%",
      },
      {
        text: "Actualizar",
        align: "center",
        value: "permiso_update",
        sortable: false,
        width: "10%",
      },
      {
        text: "Eliminar",
        align: "center",
        value: "permiso_delete",
        sortable: false,
        width: "10%",
      },
      {
        text: "Global",
        align: "center",
        value: "permiso_global",
        sortable: false,
        width: "10%",
      },
      {
        text: "Acciones",
        align: "center",
        value: "actions",
        sortable: false,
        width: "10%",
      },
    ];
  }

  public get filteredItems() {
    let items = this.datasource.tabla || [];

    // Filter by permission type
    if (this.filterType) {
      items = items.filter((item: any) => {
        switch (this.filterType) {
          case "menu":
            return item.permiso_menu && item.permiso_menu_checked;
          case "read":
            return item.permiso_read && item.permiso_read_checked;
          case "write":
            return item.permiso_write && item.permiso_write_checked;
          case "update":
            return item.permiso_update && item.permiso_update_checked;
          case "delete":
            return item.permiso_delete && item.permiso_delete_checked;
          case "global":
            return item.permiso_global && item.permiso_global_checked;
          default:
            return true;
        }
      });
    }

    return items;
  }

  public get selectedPermissionsCount() {
    return this.datasource.permisos_str
      ? this.datasource.permisos_str.length
      : 0;
  }

  public getModuleIcon(nombre: string): string {
    const name = nombre.toLowerCase();
    if (name.includes("usuario")) return "mdi-account-group";
    if (name.includes("rol")) return "mdi-shield-account";
    if (name.includes("cliente")) return "mdi-briefcase";
    if (name.includes("camara") || name.includes("cámara")) return "mdi-camera";
    if (name.includes("acceso")) return "mdi-door";
    if (name.includes("gimnasio") || name.includes("gym"))
      return "mdi-dumbbell";
    if (name.includes("subscription") || name.includes("suscri"))
      return "mdi-credit-card";
    if (name.includes("ftp")) return "mdi-folder-network";
    return "mdi-view-dashboard";
  }

  public getModuleColor(nombre: string): string {
    const name = nombre.toLowerCase();
    if (name.includes("usuario")) return "blue";
    if (name.includes("rol")) return "purple";
    if (name.includes("cliente")) return "green";
    if (name.includes("camara") || name.includes("cámara")) return "orange";
    if (name.includes("acceso")) return "teal";
    if (name.includes("gimnasio") || name.includes("gym")) return "red";
    if (name.includes("subscription") || name.includes("suscri"))
      return "indigo";
    if (name.includes("ftp")) return "brown";
    return "grey";
  }

  public getPermissionSummary(item: any): string {
    const perms = [];
    if (item.permiso_menu_checked) perms.push("Menú");
    if (item.permiso_read_checked) perms.push("Lectura");
    if (item.permiso_write_checked) perms.push("Escritura");
    if (item.permiso_update_checked) perms.push("Actualización");
    if (item.permiso_delete_checked) perms.push("Eliminación");
    if (item.permiso_global_checked) perms.push("Global");

    return perms.length > 0 ? perms.join(", ") : "Sin permisos activos";
  }

  public selectAllFiltered() {
    this.filteredItems.forEach((item: any) => {
      this.selectAllForModule(item);
    });
    MessageService.toast(
      "Todos los permisos filtrados seleccionados",
      MessageService.TypeSuccess
    );
  }

  public deselectAllFiltered() {
    this.filteredItems.forEach((item: any) => {
      this.deselectAllForModule(item);
    });
    MessageService.toast(
      "Todos los permisos filtrados deseleccionados",
      MessageService.TypeSuccess
    );
  }

  public selectAllRead() {
    this.datasource.tabla.forEach((item: any) => {
      if (item.permiso_read && !item.permiso_read_checked) {
        item.permiso_read_checked = true;
        this.update_permiso(true, item.permiso_read);
      }
    });
    MessageService.toast(
      "Permisos de lectura activados",
      MessageService.TypeSuccess
    );
  }

  public selectAllMenu() {
    this.datasource.tabla.forEach((item: any) => {
      if (item.permiso_menu && !item.permiso_menu_checked) {
        item.permiso_menu_checked = true;
        this.update_permiso(true, item.permiso_menu);
      }
    });
    MessageService.toast(
      "Permisos de menú activados",
      MessageService.TypeSuccess
    );
  }

  public selectAllForModule(item: any) {
    if (item.permiso_menu) {
      item.permiso_menu_checked = true;
      this.update_permiso(true, item.permiso_menu);
    }
    if (item.permiso_read) {
      item.permiso_read_checked = true;
      this.update_permiso(true, item.permiso_read);
    }
    if (item.permiso_write) {
      item.permiso_write_checked = true;
      this.update_permiso(true, item.permiso_write);
    }
    if (item.permiso_update) {
      item.permiso_update_checked = true;
      this.update_permiso(true, item.permiso_update);
    }
    if (item.permiso_delete) {
      item.permiso_delete_checked = true;
      this.update_permiso(true, item.permiso_delete);
    }
    if (item.permiso_global) {
      item.permiso_global_checked = true;
      this.update_permiso(true, item.permiso_global);
    }
  }

  public deselectAllForModule(item: any) {
    if (item.permiso_menu) {
      item.permiso_menu_checked = false;
      this.update_permiso(false, item.permiso_menu);
    }
    if (item.permiso_read) {
      item.permiso_read_checked = false;
      this.update_permiso(false, item.permiso_read);
    }
    if (item.permiso_write) {
      item.permiso_write_checked = false;
      this.update_permiso(false, item.permiso_write);
    }
    if (item.permiso_update) {
      item.permiso_update_checked = false;
      this.update_permiso(false, item.permiso_update);
    }
    if (item.permiso_delete) {
      item.permiso_delete_checked = false;
      this.update_permiso(false, item.permiso_delete);
    }
    if (item.permiso_global) {
      item.permiso_global_checked = false;
      this.update_permiso(false, item.permiso_global);
    }
  }

  public applyPreset(preset: string) {
    if (!preset) return;

    switch (preset) {
      case "admin":
        // Select all permissions
        this.datasource.tabla.forEach((item: any) =>
          this.selectAllForModule(item)
        );
        MessageService.toast(
          "Plantilla 'Administrador Total' aplicada",
          MessageService.TypeSuccess
        );
        break;

      case "readonly":
        // Clear all, then select only read and menu
        this.datasource.tabla.forEach((item: any) => {
          this.deselectAllForModule(item);
          if (item.permiso_read) {
            item.permiso_read_checked = true;
            this.update_permiso(true, item.permiso_read);
          }
          if (item.permiso_menu) {
            item.permiso_menu_checked = true;
            this.update_permiso(true, item.permiso_menu);
          }
        });
        MessageService.toast(
          "Plantilla 'Solo Lectura' aplicada",
          MessageService.TypeSuccess
        );
        break;

      case "editor":
        // Select read, write, update, menu
        this.datasource.tabla.forEach((item: any) => {
          this.deselectAllForModule(item);
          if (item.permiso_read) {
            item.permiso_read_checked = true;
            this.update_permiso(true, item.permiso_read);
          }
          if (item.permiso_write) {
            item.permiso_write_checked = true;
            this.update_permiso(true, item.permiso_write);
          }
          if (item.permiso_update) {
            item.permiso_update_checked = true;
            this.update_permiso(true, item.permiso_update);
          }
          if (item.permiso_menu) {
            item.permiso_menu_checked = true;
            this.update_permiso(true, item.permiso_menu);
          }
        });
        MessageService.toast(
          "Plantilla 'Editor' aplicada",
          MessageService.TypeSuccess
        );
        break;

      case "basic":
        // Only menu and read for basic modules
        this.datasource.tabla.forEach((item: any) => {
          this.deselectAllForModule(item);
          const name = item.nombre.toLowerCase();
          if (
            !name.includes("admin") &&
            !name.includes("rol") &&
            !name.includes("usuario")
          ) {
            if (item.permiso_read) {
              item.permiso_read_checked = true;
              this.update_permiso(true, item.permiso_read);
            }
            if (item.permiso_menu) {
              item.permiso_menu_checked = true;
              this.update_permiso(true, item.permiso_menu);
            }
          }
        });
        MessageService.toast(
          "Plantilla 'Usuario Básico' aplicada",
          MessageService.TypeSuccess
        );
        break;

      case "clear":
        // Clear all permissions
        this.datasource.tabla.forEach((item: any) =>
          this.deselectAllForModule(item)
        );
        MessageService.toast(
          "Todos los permisos limpiados",
          MessageService.TypeWarning
        );
        break;
    }

    // Clear preset selection
    this.selectedPreset = "";
  }

  public update_permiso(isChecked: boolean, permisoString: string) {
    if (!permisoString) return;

    const index = this.datasource.permisos_str.indexOf(permisoString);
    const existe = index > -1;

    if (isChecked && !existe) {
      this.datasource.permisos_str.push(permisoString);
    } else if (!isChecked && existe) {
      this.datasource.permisos_str.splice(index, 1);
    }
  }

  public is_new() {
    return (
      this.$route.params.id === "-1" || Number(this.$route.params.id) === -1
    );
  }

  public async aceptar() {
    const allOk = await this.$validator.validateAll();
    if (!allOk) {
      MessageService.toast(
        "Completa todos los campos requeridos",
        MessageService.TypeError
      );
      return;
    }

    this.saving = true;
    try {
      const dto = new rol_permiso();
      dto.rol = this.datasource.rol;
      dto.rol.id = Number.parseInt(this.$route.params.id);

      dto.permisos = this.datasource.permisos_str.map(
        (x) => new permiso({ id: 0, nombre: x, id_rol: dto.rol.id })
      );

      if (this.is_new()) {
        await rolModule.guardarrol_permiso(dto);
        MessageService.toast(
          "Rol creado exitosamente",
          MessageService.TypeSuccess
        );
      } else {
        await rolModule.modificarrol_permiso(dto);
        MessageService.toast(
          "Rol actualizado exitosamente",
          MessageService.TypeSuccess
        );
      }

      this.cancelar();
    } catch (e) {
      MessageService.toast("Error al guardar el rol", MessageService.TypeError);
    } finally {
      this.saving = false;
    }
  }

  public cancelar() {
    this.$router.back();
  }

  public eliminar() {
    MessageService.confirm(
      "¿Estás seguro de que deseas eliminar este rol? Esta acción no se puede deshacer.",
      "Eliminar Rol",
      async (cb: boolean) => {
        if (cb) {
          try {
            await rolModule.eliminarrol_permiso(
              Number.parseInt(this.$route.params.id)
            );
            MessageService.toast(
              "Rol eliminado correctamente",
              MessageService.TypeSuccess
            );
            this.cancelar();
          } catch (e) {
            MessageService.toast(
              "Error al eliminar el rol",
              MessageService.TypeError
            );
          }
        }
      }
    );
  }
}
